export default function CTASection() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-50">
      <div className="max-w-[1000px] mx-auto text-center">
        <div className="relative rounded-2xl md:rounded-3xl overflow-hidden mb-10">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20inviting%20retail%20display%20with%20carefully%20curated%20neutral%20toned%20products%20on%20wooden%20shelving%2C%20soft%20golden%20hour%20light%20streaming%20through%20a%20nearby%20window%2C%20natural%20textures%20and%20organic%20materials%2C%20boutique%20atmosphere%2C%20warm%20cream%20and%20oak%20palette&width=1200&height=500&seq=cta-v2-2607&orientation=landscape"
            alt="Superbuy Spreadsheet curated shopping collection"
            className="w-full h-64 md:h-80 object-cover"
          />
        </div>

        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4 leading-tight">
          Ready to Explore{' '}
          <span className="italic font-normal text-primary-500">Organized Shopping</span>?
        </h2>
        <p className="text-base md:text-lg text-foreground-600 max-w-xl mx-auto mb-8 leading-relaxed">
          Access the latest Superbuy spreadsheet collections with <strong>verified finds</strong>,
          updated product data, and curated category guides — all in one place.
        </p>

        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 px-8 py-4 bg-foreground-950 text-background-50 text-sm md:text-base font-semibold rounded-full hover:bg-foreground-800 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
        >
          Buy it Now
          <i className="ri-arrow-right-up-line text-base"></i>
        </a>
      </div>
    </section>
  );
}